export default __webpack_public_path__ + "static/media/draw_collage.2b2f0f34.svg";